
interface ProductCategoryBadgeProps {
  categoryName: string;
}

export const ProductCategoryBadge = ({ categoryName }: ProductCategoryBadgeProps) => {
  return (
    <div className="absolute top-6 right-4 md:top-4 md:right-6 bg-background/80 backdrop-blur-sm text-foreground px-3 py-1 rounded-full text-sm font-medium z-10">
      {categoryName}
    </div>
  );
};
